import { Download } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useManuscriptArchiveDownload } from "@/hooks/use-contest-submissions";
import type { ContestScreeningResult } from "@/types/contest-submission";

/**
 * 심사 판정 기준 zip 묶음. 심사 중 실제로 필요한 조합만 노출한다 —
 * "적격 + 검토중" 은 부적격만 걸러낸 남은 후보 전체를 뜻한다.
 */
const ARCHIVE_PRESETS: Array<{
  label: string;
  screeningResults: ContestScreeningResult[];
}> = [
  { label: "적격", screeningResults: ["PASS"] },
  { label: "검토중", screeningResults: ["PENDING"] },
  { label: "적격 + 검토중", screeningResults: ["PASS", "PENDING"] },
  { label: "부적격", screeningResults: ["FAIL"] },
  { label: "전체", screeningResults: ["PASS", "PENDING", "FAIL"] },
];

/**
 * 원고 zip 일괄 다운로드 버튼.
 * 목록의 검색어/페이지가 아니라 심사 판정 기준으로 묶는다 — 페이지 단위로
 * 나눠 받게 하면 심사 실무에서 누락이 생긴다.
 */
export function ContestArchiveDownload() {
  const archive = useManuscriptArchiveDownload();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={archive.isPending}>
          <Download className="mr-1.5 h-3.5 w-3.5" />
          {archive.isPending ? "준비 중…" : "원고 일괄 다운로드"}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>심사 판정 기준</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ARCHIVE_PRESETS.map((preset) => (
          <DropdownMenuItem
            key={preset.label}
            className="cursor-pointer"
            onClick={() =>
              archive.mutate({ screeningResults: preset.screeningResults })
            }
          >
            {preset.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
